import React from "react";
import "./Loader.css"; // Import your CSS file

function Loader() {
  return (
    <a className="card" id="card-link" target="_blank">
      <div className="card__body">
        {/* Child div 1 */}
        <div
          className="skeleton skeleton-text skeleton-text__body"
          style={{  border: "1px solid #ccc" }}
        ></div>

        {/* Child div 2 */}
        <div
          className="skeleton skeleton-text skeleton-text__body"
          style={{  border: "1px solid #ccc" }}
        ></div>
      </div>
    </a>
  );
}

export default Loader;